import React, { useState } from 'react';

import * as authActions from 'global/actions/authActions';
import { useActions } from 'hooks/useActions';
import { FreecodeInputContainer, FreecodeInputField, FreecodeIcon } from 'components/FormComponents/FormComponents';
import { Header, Body, Footer, FooterButton } from './freecodeModalElements';

// Get fragment with modal sign in functionality
export default function ModalContentTwoFactor({ onCancel }) {
  const { loginTwoFactor } = useActions(authActions);

  const [twoFactorCode, setTwoFactorCode] = useState('');

  const onEnterTwoFactor = (e) => e.key === 'Enter' && twoFactorCode && loginTwoFactor(twoFactorCode, true);

  return (
    <>
      <Header>Two Factor</Header>
      <Body>
        <FreecodeInputContainer>
          <FreecodeIcon className="fa-solid fa-qrcode" />
          <FreecodeInputField
            type="text"
            autoFocus
            value={twoFactorCode}
            placeholder="Enter two factor authentication code"
            onChange={(e) => setTwoFactorCode(e.target.value)}
            onKeyDown={onEnterTwoFactor}
          />
        </FreecodeInputContainer>
      </Body>
      <Footer>
        <FooterButton
          isFreecodeAuthPrimaryButton
          onClick={() => loginTwoFactor(twoFactorCode, true)}
          disabled={!twoFactorCode}
        >
          Confirm
        </FooterButton>
        <FooterButton isFreecodeAuthCancelButton onClick={onCancel}>
          Cancel
        </FooterButton>
      </Footer>
    </>
  );
}
